import cart from './cart'
export default `mutation viewideSetShippingMethodOnCart($input: viewideSetShippingMethodOnCartInput) {
  viewideSetShippingMethodOnCart(input: $input) {
    cart { ${cart} }
  }
 }
`
